export default "__VITE_ASSET__Bc3R$Gvw__"